<div [formGroup]="form">
	<div class="pv-input">
		@if (label) {
			<ic-label [help]="help" [missing]="missing" [missingText]="missingText" [required]="required">
				{{ label }}
			</ic-label>
		}

		@if (showAddressForm$ | async) {
			<ic-address-form [address]="address" (cancelItem)="clear()" (saveItem)="onLocationFormSave($event)" />
		} @else {
			<div class="border">
				<ng-container>
					@if (icon) {
						<i aria-hidden="true" [ngClass]="[icon, 'icon']"></i>
					}
				</ng-container>
				<input
					formControlName="text"
					icAutocompletionPlace
					[class]="inputClass"
					[placeholder]="placeholder"
					[type]="type"
					(blur)="onBlur()"
					(selectedPlace)="placeChangedCallback($event)"
				/>
				@if (!form.get("text").value) {
					<i aria-hidden="true" class="caret fa fa-search"></i>
				} @else {
					<i aria-hidden="true" class="caret fa fa-times" (click)="clear()"></i>
				}
			</div>
			@if (form.hasError("noCountryCode")) {
				<p class="errors">{{ "error.noCountryCode" | translate }}</p>
			}
			<ng-content select=".errors" />
		}
	</div>
</div>
